import {TicketInfoVo} from '../../common/shared/api/gateway/TicketInfoVo.interface';
import {TicketInfo} from '../generated/types';
import {createTicketKind} from './TicketKind';
import {createTicketType} from './TicketType';

export function createTicketInfo({
  ticket_id,
  ticket_type,
  price,
  discount_price,
  rental_period_by_minute,
}: TicketInfoVo): TicketInfo {
  return {
    ticketId: ticket_id,
    ticketType: createTicketType(ticket_type),
    ticketKind: createTicketKind(ticket_type),
    price,
    discountPrice: discount_price,
    rentalPeriodByMinute: rental_period_by_minute,
  };
}
